if(document.querySelector(".latest-banners-image")){
    var swiper = new Swiper(".latest-banners-image", {
        pagination: {
            el: ".swiper-pagination",
        },
    });
}

if(document.querySelector(".testimonials-section")){
    var swiper2 = new Swiper(".testimonials-section", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

document.querySelectorAll(".add-to-card-grid").forEach(function (add) {
    add.addEventListener("click", function (e) {
        e.preventDefault();
        var data = new FormData(this.parentElement);
        var btn = this;
        btn.setAttribute("disabled", "disabled");
        fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: data
        })
            .then(response => response.json())
            .then(function (data) {
                if (data.status === 422) {
                    this.error(data);
                    btn.removeAttribute("disabled");
                    alert(data);
                } else {

                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                        bubbles: true
                    }));
                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
                        btn.removeAttribute("disabled");
                    }, 1000);

                }

            }.bind(this));
    })
})

document.querySelector(".close-annoucement").addEventListener("click", function () {
    document.querySelector(".latest-announcement-bar").style.display = 'none';
})